export const Pricing = () => (
  <div className="pricing tnm-v1">
    <main className="main">
      <section className="page-hero">
        <div className="page-header">
          <div className="container">
            <h1>Pricing</h1>
          </div>
        </div>
      </section>

      <section className="pricing-grid">
        <div className="container">
          <div className="pricing-block">
            <h2>Ultra Micro</h2>
            <p>
              Our smallest meals, recommended for people who are looking to lose
              weight and stay healthy.
            </p>
            <div className="price-list">
              <div className="title">
                <span>
                  <h3>5 days per week</h3>
                </span>
                <span>
                  <h3>6 days per week</h3>
                </span>
              </div>
              <div className="meal-info">
                <span>
                  <h3>3 Meals Daily</h3>
                </span>
                <span>£406.25</span>
                <span>£487.50</span>
                <span>(£6.25 per meal)</span>
              </div>
              <div className="meal-info">
                <span>
                  <h3>2 Meals Daily</h3>
                </span>
                <span>£270.83</span>
                <span>£325.00</span>
                <span>(£6.25 per meal)</span>
              </div>
              <div className="meal-info">
                <span>
                  <h3>1 Meals Daily</h3>
                </span>
                <span>£137.58</span>
                <span>£165.50</span>
                <span>(£6.35 per meal)</span>
              </div>
            </div>
          </div>
          <div className="pricing-block">
            <h2>Micro</h2>
            <p>
              Smaller meals for people looking to cut back a little or those who
              are not overly active.
            </p>
            <div className="price-list">
              <div className="title">
                <span>
                  <h3>5 days per week</h3>
                </span>
                <span>
                  <h3>6 days per week</h3>
                </span>
              </div>
              <div className="meal-info">
                <span>
                  <h3>3 Meals Daily</h3>
                </span>
                <span>£430.95</span>
                <span>£517.14</span>
                <span>(£6.63 per meal)</span>
              </div>
              <div className="meal-info">
                <span>
                  <h3>2 Meals Daily</h3>
                </span>
                <span>£287.30</span>
                <span>£344.76</span>
                <span>(£6.63 per meal)</span>
              </div>
              <div className="meal-info">
                <span>
                  <h3>1 Meals Daily</h3>
                </span>
                <span>£145.80</span>
                <span>£174.98</span>
                <span>(£6.73 per meal)</span>
              </div>
            </div>
          </div>
          <div className="pricing-block">
            <h2>Equilibrium</h2>
            <p>
              Regular sized meals, recommended for people looking to stay
              consistently healthy &amp; maintain weight.
            </p>
            <div className="price-list">
              <div className="title">
                <span>
                  <h3>5 days per week</h3>
                </span>
                <span>
                  <h3>6 days per week</h3>
                </span>
              </div>
              <div className="meal-info">
                <span>
                  <h3>3 Meals Daily</h3>
                </span>
                <span>£494.00</span>
                <span>£592.80</span>
                <span>(£7.60 per meal)</span>
              </div>
              <div className="meal-info">
                <span>
                  <h3>2 Meals Daily</h3>
                </span>
                <span>£329.33</span>
                <span>£395.20</span>
                <span>(£7.60 per meal)</span>
              </div>
              <div className="meal-info">
                <span>
                  <h3>1 Meals Daily</h3>
                </span>
                <span>£170.52</span>
                <span>£204.62</span>
                <span>(£7.87 per meal)</span>
              </div>
            </div>
          </div>
          <div className="pricing-block">
            <h2>Mass</h2>
            <p>
              Large, nutritionally balanced meals, with extra protein for active
              people who are looking to gain lean muscle.
            </p>
            <div className="price-list">
              <div className="title">
                <span>
                  <h3>5 days per week</h3>
                </span>
                <span>
                  <h3>6 days per week</h3>
                </span>
              </div>
              <div className="meal-info">
                <span>
                  <h3>3 Meals Daily</h3>
                </span>
                <span>£575.25</span>
                <span>£690.30</span>
                <span>(£8.85 per meal)</span>
              </div>
              <div className="meal-info">
                <span>
                  <h3>2 Meals Daily</h3>
                </span>
                <span>£383.50</span>
                <span>£460.20</span>
                <span>(£8.85 per meal)</span>
              </div>
              <div className="meal-info">
                <span>
                  <h3>1 Meals Daily</h3>
                </span>
                <span>£195.43</span>
                <span>£234.52</span>
                <span>(£9.02 per meal)</span>
              </div>
            </div>
          </div>
          <div className="pricing-block">
            <h2>Extra</h2>
            <p>
              We also offer these balanced extras with every plan (priced
              individually)
            </p>
            <div className="price-list extra">
              <div className="meal-info">
                <span>
                  <h3>Breakfast</h3>
                </span>
                <span>£6.00</span>
              </div>
              <div className="meal-info">
                <span>
                  <h3>Snack (Large)</h3>
                </span>
                <span>£3.75</span>
              </div>
              <div className="meal-info">
                <span>
                  <h3>Snack (Standard)</h3>
                </span>
                <span>£2.75</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
);
